import { render, staticRenderFns } from "./CustomerTelephone.vue?vue&type=template&id=6101f129&"
import script from "./CustomerTelephone.vue?vue&type=script&lang=ts&"
export * from "./CustomerTelephone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports